(function (global) {
  function initGeekoYouTubePlayer({ keyId, videoId,autoplay=true }) {
    if (!keyId || !videoId) {
      console.error("initGeekoYouTubePlayer requires keyId and videoId");
      return;
    }

    const video_container_id = "video-container-" + keyId;
    const player_id = "player-" + keyId;
    const video_overlay_id = "video-overlay-" + keyId;
    const sound_control_id = "sound-control-" + keyId;

    const videoContainer = document.getElementById(video_container_id);
    if (!videoContainer) {
      console.warn("Video container not found:", video_container_id);
      return;
    }

    // 初始化 HTML 结构
    videoContainer.innerHTML = `
      <div id="${player_id}" style="width: 100%; height: 100%;"></div>

      <div id="${video_overlay_id}" style="
        position: absolute;
        top: 0; left: 0;
        width: 100%; height: 100%;
        z-index: 5;
        background: transparent;
        cursor: pointer;
      "></div>

      <div id="${sound_control_id}" style="
        position: absolute;
        bottom: 100px;
        right: 10px;
        width: 32px;
        height: 32px;
        background-image: url('https://image.geeko.ltd/chicme/2022062302/mute.svg');
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        border-radius: 50%;
        cursor: pointer;
        z-index: 10;
      "></div>
    `;
    videoContainer.style.position = "relative";
    videoContainer.style.overflow = "hidden";

    const soundControl = document.getElementById(sound_control_id);
    const videoOverlay = document.getElementById(video_overlay_id);
    const playerContainer = document.getElementById(player_id);

    let player;
    let isMuted = true;
    let isPaused = false;

    // ---------------------------
    // YouTube API 管理器（全局单例）
    // ---------------------------
    if (!window.YouTubeAPIManager) {
      window.YouTubeAPIManager = {
        isLoaded: false,
        isLoading: false,
        callbacks: [],
        load(callback) {
          if (this.isLoaded) return callback();
          this.callbacks.push(callback);
          if (this.isLoading) return;
          this.isLoading = true;
          const tag = document.createElement("script");
          tag.src = "https://www.youtube.com/iframe_api";
          document.head.appendChild(tag);
        },
        onReady() {
          this.isLoaded = true;
          this.isLoading = false;
          this.callbacks.forEach((cb) => cb());
          this.callbacks = [];
        },
      };
      window.onYouTubeIframeAPIReady = function () {
        window.YouTubeAPIManager.onReady();
      };
    }

    // ---------------------------
    // 初始化播放器
    // ---------------------------
    function loadYouTubeAPI() {
      window.YouTubeAPIManager.load(initPlayer);
    }

    function initPlayer() {
      if (!playerContainer || playerContainer.querySelector("iframe")) return;
      try {
        player = new YT.Player(player_id, {
          height: "100%",
          width: "100%",
          videoId: videoId,
          playerVars: {
            autoplay:autoplay,
            controls: 0,
            modestbranding: 1,
            rel: 0,
            playsinline: 1,
            mute: 1,
          },
          events: {
            onReady: onPlayerReady,
            onError: onPlayerError,
            onStateChange: onPlayerStateChange,
          },
        });
      } catch (e) {
        console.error("YT init error:", e);
      }
    }

    function onPlayerReady(event) {
      videoOverlay.__ytPlayer = player;
      updateSoundIcon();
    }

    function onPlayerError(event) {
      console.error("YouTube player error:", event.data, player_id);
    }

    function onPlayerStateChange(event) {
      try {
        if (event.data === YT.PlayerState.PLAYING) isPaused = false;
        if (event.data === YT.PlayerState.PAUSED) isPaused = true;
        if (event.data === YT.PlayerState.ENDED) {
          const endedEvent = new CustomEvent("videoEnded", {
            bubbles: true,
            detail: { playerId: player_id },
          });
          videoContainer.dispatchEvent(endedEvent);
        }
      } catch (e) {
        console.warn("onPlayerStateChange error:", e);
      }
    }

    // ---------------------------
    // 控制逻辑
    // ---------------------------
    function toggleMute(e) {
      e.preventDefault();
      e.stopPropagation();
      if (!player) return;
      if (isMuted) {
        player.unMute();
        isMuted = false;
      } else {
        player.mute();
        isMuted = true;
      }
      updateSoundIcon();
    }

    function updateSoundIcon() {
      soundControl.style.backgroundImage = isMuted
        ? "url('https://image.geeko.ltd/chicme/2022062302/mute.svg')"
        : "url('https://image.geeko.ltd/chicme/2022062302/unmute.svg')";
    }

    function togglePlayPause(e) {
      console.log("点击暂停2222");
      e.preventDefault();
      e.stopPropagation();
      if (!player) return;
      if (isPaused) {
          player.playVideo();
          isPaused = false;
      } else {
          player.pauseVideo();
          isPaused = true;
      }
    }

    // ---------------------------
    // 绑定事件
    // ---------------------------
    ["click", "touchstart"].forEach((evt) => {
      soundControl.addEventListener(evt, toggleMute, { passive: false });
    });
    // 如需启用点击暂停功能，可解开：
    ["click", "touchstart"].forEach(evt => {
      videoOverlay.addEventListener(evt, togglePlayPause, { passive: false });
    });

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", loadYouTubeAPI);
    } else {
      loadYouTubeAPI();
    }
  }

  // 暴露全局函数
  global.initGeekoYouTubePlayer = initGeekoYouTubePlayer;
})(window);
